import Container from "../../../../components/container";
import { ContactUs } from "../../../../models";
import { UpdateButton } from "./buttons";

export default function ContactUsTable({
  messages,
}: {
  messages: ContactUs[];
}) {
  return (
    <Container className="">
      {/* Mobile layout */}
      <div className="lg:hidden">
        {messages?.map((message) => (
          <div
            key={message.id}
            className="mb-2 w-full rounded-md bg-white p-4"
          >
            <h2>{message.name}</h2>
            <div className="flex items-center justify-between  pb-4 mt-2">
              <div className="flex items-center gap-2">
                <p>Email:</p>
                <p className="text-sm text-gray-500">{message.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <p className="text-sm text-gray-500">{message.subject}</p>
            </div>
            <UpdateButton id={message.id}/>
          </div>
        ))}
      </div>

      {/* Desktop table */}
      <table className="hidden min-w-full text-gray-900 text-left lg:table ">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th className="px-6 py-3">Name</th>
            <th className="px-6 py-3">Email</th>
            <th className="px-6 py-3">Subject</th>
            <th className="px-6 py-3">Replayed</th>
            <th className="px-6 py-3">Edit</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {messages.map((message) => (
            <tr key={message.id} className="border-b">
              <td className="whitespace-nowrap px-6 py-3">{message.name}</td>
              <td className="px-6 py-4">{message.email}</td>
              <td className="px-6 py-4">{message.subject}</td>
              <td className="px-6 py-4">{message.replayed ? "Yes" : "No"}</td>
              <td className="px-6 py-2"><UpdateButton id={message.id}/></td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}

